import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { canAccessBillingUrl } from '../services/billing-navigation-rules';

/**
 * Billing module guard. Also a child guard: the KPI page opens to roles (billing_manager,
 * billing-kpi) that must not reach the other Billing pages, and a parent-only guard is not
 * re-run when navigating from one Billing page to another.
 */
@Injectable({ providedIn: 'root' })
export class BillingGuard implements CanActivate, CanActivateChild {
  private authService = inject(AuthService);

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.isAllowed(state.url);
  }

  canActivateChild(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.isAllowed(state.url);
  }

  private isAllowed(url: string): boolean {
    try {
      return canAccessBillingUrl(url, this.authService.currentUser()?.group ?? []);
    } catch {
      return false;
    }
  }
}
